import Vue from 'vue';
import Router from 'vue-router';
import { getMenu } from '@/api/auth';

/**
 * Layzloading will create many files and slow on compiling, so best not to use lazyloading on devlopment.
 * The syntax is lazyloading, but we convert to proper require() with babel-plugin-syntax-dynamic-import
 * @see https://doc.laravue.dev/guide/advanced/lazy-loading.html
 */

Vue.use(Router);

/* Layout */
import Layout from '@/layout';

/* Router for modules */
import systemRoutes from './modules/system';
import optimizeRoutes from './modules/optimize';
import auxiliaryRoutes from './modules/auxiliary';
import superiorRoutes from './modules/superior';
/**
 * Sub-menu only appear when children.length>=1
 * @see https://doc.laravue.dev/guide/essentials/router-and-nav.html
 **/

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    roles: ['admin', 'editor']   Visible for these roles only
    permissions: ['view menu zip', 'manage user'] Visible for these permissions only
    title: 'title'               the name show in sub-menu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if true, the page will no be cached(default is false)
    breadcrumb: false            if false, the item will hidden in breadcrumb (default is true)
    affix: true                  if true, the tag will affix in the tags-view
  }
**/

export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect'),
      },
    ],
  },
  {
    path: '/login',
    component: () => import('@/views/login/sync.vue'),
    hidden: true,
    children: [
      {
        path: 'sync',
        component: () => import('@/views/login/sync.vue'),
      },
    ],
  },
  {
    path: '',
    component: Layout,
    redirect: 'dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard'),
        name: 'Dashboard',
        meta: { title: 'dashboard', icon: 'ali-dashboard', noCache: false },
      },
    ],
  },
];
let _menu = [];
const _asyncRoutes = [
  /** 优化管理 */
  optimizeRoutes,
  /** 辅助工具 */
  auxiliaryRoutes,
  /** 系统管理 */
  systemRoutes,
  /** 体验版 */
  superiorRoutes,
];

getMenu().then(response => {
  _menu = resetMenu(response.list);
  resetNowRouter(_asyncRoutes);
});

function resetMenu(list) {
  const new_menu = [];
  function forMenu(_list) {
    _list.forEach(item => {
      new_menu.push(item);
      if (item.children && item.children.length !== 0) {
        forMenu(item.children);
      }
      delete item.children;
    });
  }
  forMenu(list);
  return new_menu;
}

function resetNowRouter(list) {
  list.forEach(item => {
    const _menu_item = _menu.find(
      _data => _data.menu_permission === item.meta.permissions
    );
    if (_menu_item) {
      item.path = _menu_item.api_url;
    } else {
      item.path = '/404';
    }
    if (item.children) {
      resetNowRouter(item.children);
    }
  });
}

export const asyncRoutes = _asyncRoutes;

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    mode: 'history',
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
